import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    details: "",
  },
  reducers: {
    user: (state, action) => {
      return {
        ...state,
        details: { ...state.details, ...action.payload },
      };
    },
  },
});

export const { user } = userSlice.actions;

export default userSlice.reducer;
